import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { BackgroundAssetServices } from "@/services/bedrock/BackgroundAssetServices";
import { BackgroundSearchBody, BackgroundSearchPage } from "@/services/bedrock/dtos/BackgroundAsset";
import { designKeys } from "@/services/bedrock/queryKeys";

/** Cursor-paged library search. Callers debounce `q` before it reaches `body`. */
export function useBackgroundLibrary(body: BackgroundSearchBody, { enabled = true }: { enabled?: boolean } = {}) {
  const query = useInfiniteQuery({
    queryKey: designKeys.backgrounds.search(body),
    queryFn: ({ pageParam }) => BackgroundAssetServices.search(pageParam ? { ...body, cursor: pageParam } : body),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last: BackgroundSearchPage) =>
      last.pagination.hasMore ? last.pagination.nextCursor ?? undefined : undefined,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
    enabled,
  });

  const pages = query.data?.pages ?? [];
  return {
    assets: pages.flatMap(page => page.content),
    matches: pages[0]?.matches ?? null,
    fetchNextPage: query.fetchNextPage,
    hasNextPage: query.hasNextPage,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    refetch: query.refetch,
  };
}
